export function roundDown(number: number, decimals: number): number {
    const multiplier = 10 ** decimals;
    return Math.floor(number * multiplier) / multiplier;
}
